import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { Offer } from '../models/offer';

export class OfferApi {
    constructor(protected baseUrl: string) {}

    public updateOffers(inquiryId: number, offers: Partial<Offer>[]): Promise<ApiResult<void>> {
        return safeRequest(() => request.post(`${this.baseUrl}/inquiries/${inquiryId}/offers`, { offers }), noop);
    }
}
